import type { ITransactionStatus } from "@/modules/transaction/common/types";
import {
  OperationStatus,
  OperationStatusTextColor,
  TransactionDirection,
  UiType
} from "@/shared/common/enums";
import { Amount } from "@/shared/components";
import { MoreIcon, SpendingIcon } from "@/shared/components/SvgIcons";
import { Divider } from "@ab.uitools/ui-library/components/Divider";
import { Text } from "@ab.uitools/ui-library/components/Text";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

interface Props {
  isLast: boolean;
  isInWidget?: boolean;
  withActions?: boolean;
  amount?: number;
  beneficiary?: string;
  currency: string;
  state?: ITransactionStatus;
  purpose?: string;
  description?: string;
  transactionDirection?: TransactionDirection
}

export const HistoryItem = ({
  amount,
  beneficiary,
  currency,
  state,
  isLast,
  isInWidget = false,
  withActions,
  purpose,
  description,
  transactionDirection,
}: Props) => {
  const { t } = useTranslation();
  const type = transactionDirection ?
    (transactionDirection === TransactionDirection.In ?
      UiType.Success : UiType.Danger) : "";
  return (
    <div className={classNames("history-item", { "widget-content-item pl-32 pr-32": isInWidget })}>
      <div className="item-icon flexbox align-items--center justify-content--center">
        <div className="flexbox align-items--center justify-content--center">
          <SpendingIcon/>
        </div>
      </div>
      <div className="history-item--item-wrapper">
        <div
          className="full-width flexbox align-items--center justify-content--between pt-20 pb-20 history-item-body">
          <div className="history-item--item truncate-block">
            <Text size="medium" weight="semibold" className="pr-16 truncate">
              {purpose || description}
            </Text>
            {beneficiary && (
              <Text className="pr-40 truncate mt-4" type="tertiary">
                {beneficiary}
              </Text>
            )}
          </div>
          <div className="flexbox align-items--center">
            <div
              className="flexbox justify-content--center align-items--end flex-direction--column pl-16">
              <div className="flexbox align-items--center">
                {transactionDirection && !!amount && (
                  <Text {...(type && { type })} className="pr-4" size="medium" weight="bold">
                    {!!transactionDirection && (
                      transactionDirection === TransactionDirection.In ? "+" : "-"
                    )}
                  </Text>
                )}
                {!!amount && (
                  <Amount
                    amount={amount}
                    currency={currency}
                    {...(!isInWidget && type && { type })}
                  />
                )}
              </div>
              {state && (
                <Text
                  className="text-nowrap"
                  type={OperationStatusTextColor[state?.transactionStatus]}>
                  {t(`documentStatus.${OperationStatus[state?.transactionStatus]}`)}
                </Text>
              )}
            </div>
            {withActions && (
              <div className="cursor-pointer">
                <MoreIcon type="secondary"/>
              </div>
            )}
          </div>
        </div>
        {!isLast && (
          <Divider
            color="light"
            type="primary"
            isHorizontal
          />
        )}
      </div>
    </div>
  );
};
